import { render, staticRenderFns } from "./Supplierslist.vue?vue&type=template&id=0809aa54&scoped=true"
import script from "./Supplierslist.vue?vue&type=script&lang=js"
export * from "./Supplierslist.vue?vue&type=script&lang=js"
import style0 from "./Supplierslist.vue?vue&type=style&index=0&id=0809aa54&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0809aa54",
  null
  
)

export default component.exports